var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgNetworks = function SvgNetworks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1F313A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14.75A11.25 11.25 0 1037.25 26 11.263 11.263 0 0026 14.75zm0 21c-1.549 0-3.17-1.996-3.975-5.25h7.95c-.805 3.254-2.426 5.25-3.975 5.25zM21.72 29a20.518 20.518 0 010-6h8.56c.148.993.222 1.996.22 3a19.976 19.976 0 01-.22 3h-8.56zm-5.47-3c0-1.019.162-2.031.477-3h3.488a21.086 21.086 0 000 6h-3.488a9.704 9.704 0 01-.477-3zM26 16.25c1.549 0 3.17 1.997 3.975 5.25h-7.95c.805-3.253 2.426-5.25 3.975-5.25zM31.785 23h3.488a9.675 9.675 0 010 6h-3.488c.143-.994.214-1.996.215-3 0-1.004-.072-2.006-.215-3zm2.856-1.5h-3.125a12.577 12.577 0 00-1.926-4.556 9.798 9.798 0 015.05 4.556zM22.41 16.944a12.576 12.576 0 00-1.925 4.556h-3.126a9.797 9.797 0 015.05-4.556zM17.36 30.5h3.125c.333 1.631.988 3.18 1.925 4.556a9.797 9.797 0 01-5.05-4.556zm12.23 4.556a12.577 12.577 0 001.925-4.556h3.126a9.798 9.798 0 01-5.05 4.556z",
    fill: "#56CCF2"
  })));
};

export default SvgNetworks;